export function detectDevicesAndBrowser() {
    
    const $body = $("body");
    const $window = $(window);
    
    isTouch();
    isSafari();
    
    function isTouch() {
        return "ontouchstart" in window ? $body.addClass("touch") : $body.addClass("no-touch");
    }
    
    function isSafari() {
        if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ) {
            $body.addClass("safari");
        }
    }
    
    $window.on("load", () => {
        $body.addClass("load");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/module.js